import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3995e6aa&scoped=true&"
import script from "./app.component.ts?vue&type=script&lang=ts&"
export * from "./app.component.ts?vue&type=script&lang=ts&"
import style0 from "./app.vue?vue&type=style&index=0&id=3995e6aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995e6aa",
  null
  
)

export default component.exports